/**
 * Created by Bowen on 5/24/2020.
 * Description:
 * Add contact body component
 * In this component, it need to get the contact profile information and will parse
 * need to get the contact relationship information and parse
 * need to get the contact activity informaton and parse, and for this part, need to get the note, calendar and task list
 * ------ maintenance history ------
 * Updated by Daniel on 9/6/2022 - Listen the changing of contact when click sync event on detail page.
 */
import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { ContactInformationDetail, ContactInformationItemSubject, ContactInformationItemDetail, TriggerSource } from './contact-detail-template/contact-information-item/contact-information-item.model';
import { Contact } from '../../tamalelibs/models/contact.model';
import { RelationshipTreeService } from '../../services/relationship-tree.service';
import { Subscription, fromEvent } from 'rxjs';
import { ContactComponentActionTypes, ContactComponentCategory, ContactBasicInformationCategory, RelationshipTreeShowAs, ContactTileConfig } from './contact-body-detail.model';
import { ContactService } from '../../tamalelibs/services/contact.service';
import { catchError, filter, map, take } from 'rxjs/operators';
import { ContactDetailService } from './contact-body-detail.service';
import { Store, select } from '@ngrx/store';
import { lastCustomActionSelector } from '../../redux/reducers/action-history.reducer';
import {
    UPDATE_NOTE_SUCCESS, CREATE_NOTE_SUCCESS, DELETE_NOTE_SUCCESS, UPDATE_EVENT_SUCCESS, CREATE_EVENT_SUCCESS,
    DELETE_EVENT_SUCCESS
} from '../../tamalelibs/redux/note.actions';
import { RelationshipTreeActions } from '../relationship-tree/relationship-tree.view-model';
import { GET_CONTACT_SUCCESS, EDIT_CONTACT_SUCCESS } from '../../tamalelibs/redux/app.actions';
import { CREATE_ENTITY_SUCCESS } from '../../tamalelibs/redux/entity.actions';
import { WorkflowTaskService } from '../../tamalelibs/services/workflow-task.service';
import { WorkflowTaskActionTypes } from '../../tamalelibs/redux/actions/workflow-task.actions';
import { contactTemplateConfigSelector } from '../../tamalelibs/redux/contact.reducer';
import { UsersActionTypes } from '../../redux/actions/users.actions';
import { StoreQuerierService } from '../../services/store-querier.service';
import { userSettingSelector } from '../../redux/reducers/users.reducer';
import { AUTO_SAVE_INTERVAL_3 } from '../../tamalelibs/constants/business.constants';
import { SlideSheetService } from '../../services/slide-sheet.service';
import { SlideSheetEventTypes } from '../slide-sheet/slide-sheet.model';

@Component({
    selector: 'tam-contact-body-detail',
    templateUrl: './contact-body-detail.component.html',
    styleUrls: ['./contact-body-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactBodyDetailComponent implements OnInit, OnDestroy {
    @Input() config;
    @ViewChild('child') child: any;
    currentContact: Contact;
    // below var is for sub-component data
    contactInformation: Array<ContactInformationDetail> = [];
    contactRelationship = [];
    contactActivity = {
        contactID: '',
        isContactActivity: true
    };
    contactAddress: Array<ContactInformationItemDetail> = [];
    // below var is for contact profile data
    isContactProfileHasData = false;
    basicInfo: Array<any>;
    contactInfo: Array<any>;
    currentEmploymentInfo: Array<any>;
    formerEmploymentInfo: Array<any>;
    employmentInfo: Array<any>;
    internet: Array<any>;
    otherInfo: Array<any>;
    windowSize: number;
    // for this component to make sure if the component data is ready
    isDataPrepare = false;
    // below var will record the position for every component
    // according to request: only position 1 and position 3 has collapse function
    configForPageComponent: Array<ContactTileConfig> = []; // this var is for component position
    dataForPageComponent: Array<any> = []; // this var is for all the component data
    isPosition1Collapse = false; // this var is adjust if the position 1 is collapse
    isPosition3Collapse = false; // this var is adjust if the position 3 is collapse

    // below data is used for activity component
    currentNotePge = 1;
    // from the old 7 days and later 7 days
    activitySearchCondition = {
        startDate: this._getDateAfterDays(-7)
    };

    // this variable is for that: because we can set the contact template in the template setting dialog
    // and some control is not sure to show
    // so, we need to get the value to decide if this control will show in the detail page
    // below variable is for this
    templateSettings = null;
    triggerSource = TriggerSource.Detail;

    private _destroySubscriptions: Array<Subscription> = [];
    private _timer: any;

    constructor(
        private _contactService: ContactService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _contactDetailService: ContactDetailService,
        private _store: Store<any>,
        private _relationshipTreeService: RelationshipTreeService,
        private _workflowTaskService: WorkflowTaskService,
        private _storeQuerier: StoreQuerierService,
        private _slideSheetService: SlideSheetService
    ) { }

    ngOnInit() {
        this.windowSize = window.innerWidth; // init the window size
        this.currentContact = this.config;
        this.contactActivity.contactID = this.config.id;
        this._destroySubscriptions.push(
            // change component or collapse or expand tile
            this._contactDetailService.action$.subscribe(res => {
                if (res.type === ContactComponentActionTypes.CHANGE_COMPONENT) {
                    this._changeComponent(res);
                } else if (res.type === ContactComponentActionTypes.COLLAPSE_TILE || res.type === ContactComponentActionTypes.EXPAND_TILE) {
                    this._changeLayout(res);
                } else if (res.type === ContactComponentActionTypes.CHANGE_TAB) {
                    this._changeTab(res);
                } else if (res.type === ContactComponentActionTypes.CHANGE_RELATIONSHIP_SHOW_AS) {
                    this._changeRelationshipShowAs(res);
                }
                this._autoSave();
                this._changeDetectorRef.detectChanges();
            }),

            // watch the window resize
            fromEvent(window, 'resize').subscribe((e: any) => {
                this.windowSize = e.target.innerWidth;
                this.isPosition1Collapse = false;
                this.isPosition3Collapse = false;
            }),

            this._store.pipe(
                select(lastCustomActionSelector)
            ).subscribe(action => this._actionMessageHandler(action)),

            this._relationshipTreeService.relationshipTreeOperate$.subscribe(action => {
                this._actionMessageHandler(action);
            }),

            this._store.pipe(
                select(contactTemplateConfigSelector),
                map(res => res.templateSetting),
                filter(templateSettings => !!templateSettings)
            ).subscribe(templateSettings => {
                this.templateSettings = templateSettings;
                this._initContactInformation();
            }),

            // Listening the change of the contact
            this._slideSheetService.slideSheetFeedbackSubject$.subscribe(res => {
                // Update contact information
                if (res.type === SlideSheetEventTypes.CONTACT_VALUE_CHANGE) {
                    this.currentContact = res.payload;
                    this._initContactInformation();
                    this._initEveryTile();
                    this.isDataPrepare = true;
                    this._changeDetectorRef.detectChanges();
                }
            }),
        );

    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    // will go on finish this refresh function
    private _actionMessageHandler(action): void {
        if (action.type === UPDATE_NOTE_SUCCESS || action.type === CREATE_NOTE_SUCCESS ||
            action.type === DELETE_NOTE_SUCCESS || action.type === UPDATE_EVENT_SUCCESS ||
            action.type === CREATE_EVENT_SUCCESS || action.type === DELETE_EVENT_SUCCESS) {
            this.child.getEventAndNoteData();
        } else if (action.type === RelationshipTreeActions.CHANGE_RELATIONSHIP || action.type === RelationshipTreeActions.ADD_RELATIONSHIP
            || action.type === RelationshipTreeActions.REMOVE_RELATIONSHIP || action.type === RelationshipTreeActions.EDIT_DETAILS) {
            // need to get the contact first, and then refresh the relationship tree
            this._refreshRelationshipTile();
        } else if (action.type === EDIT_CONTACT_SUCCESS || action.type === CREATE_ENTITY_SUCCESS) {
            this._getContactDetailPageData();
        } else if (action.type === WorkflowTaskActionTypes.EDIT_QUICK_TASK_SUCCESS) {
            this.child.getContactTaskData();
        }
    }

    // will save the contact detail page config every 3 minutes
    private _autoSave(): void {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
        this._timer = setTimeout(() => {
            const config = [];
            this.configForPageComponent.forEach(item => {
                if (item.componentType === ContactComponentCategory.ContactRelationships) {
                    config.push({
                        componentType: item.componentType,
                        position: item.position,
                        selectedTab: item.selectedTab,
                        isCollapsed: item.isCollapsed,
                        showAs: item.showAs
                    });
                } else {
                    config.push({
                        componentType: item.componentType,
                        position: item.position,
                        selectedTab: item.selectedTab,
                        isCollapsed: item.isCollapsed
                    });
                }
            });
            const userSettingConfig = {
                contactDetailPreference: { config: config }
            };
            this._store.dispatch({
                type: UsersActionTypes.UPDATE_USER_SETTING,
                payload: userSettingConfig
            });
        }, AUTO_SAVE_INTERVAL_3);
    }

    private _changeRelationshipShowAs(res): void {
        this.configForPageComponent.forEach(item => {
            if (item.componentType === res.payload.origin && item.position === res.payload.originPosition) {
                // here just need to change the showAs, we cannot change the other attributes
                item.showAs = res.payload.showAs;
            }
        });
    }

    // init contact information
    private _initContactInformation(): void {
        // below is for contact detail component information
        this._getRelationshipsTileData(); // get relationship for relationships part
        this._getContactProfileInfo(); // get contact information in left panel
        this._initEveryTile();
        this.isDataPrepare = true;
    }

    // for this function, will set the data for each blank space
    private _initEveryTile(): void {
        const userSetting = this._storeQuerier.queryBySelector(userSettingSelector);
        this.configForPageComponent = [];
        this.dataForPageComponent = [];
        this.dataForPageComponent = [
            { componentType: ContactComponentCategory.ContactRelationships, data: this.contactRelationship },
            { componentType: ContactComponentCategory.ContactNote, data: this.currentContact.notes },
            { componentType: ContactComponentCategory.ContactActivity, data: this.contactActivity },
            { componentType: ContactBasicInformationCategory.Address, data: this.contactAddress },
            { componentType: ContactBasicInformationCategory.BasicInformation, data: this.basicInfo },
            { componentType: ContactBasicInformationCategory.ContactInformation, data: this.contactInfo },
            { componentType: ContactBasicInformationCategory.Employment, data: this.employmentInfo },
            { componentType: ContactBasicInformationCategory.Internet, data: this.internet },
            { componentType: ContactBasicInformationCategory.Other, data: this.otherInfo }];
        if (userSetting && userSetting.contactDetailPreference && userSetting.contactDetailPreference.configuration && userSetting.contactDetailPreference.configuration.config) {
            userSetting.contactDetailPreference.configuration.config.forEach((element, index) => {
                const item = this.dataForPageComponent.filter(dataItem => dataItem.componentType === element.componentType)[0];
                if (item) {
                    const basicItem: ContactTileConfig = {
                        componentType: element.componentType,
                        data: item.data,
                        position: element.position,
                    };
                    if (element.componentType === ContactComponentCategory.ContactRelationships) {
                        basicItem.showAs = element.showAs;
                    }
                    if (element.componentType === ContactComponentCategory.ContactRelationships || element.componentType === ContactComponentCategory.ContactActivity) {
                        // only relationship and activity has the tab
                        basicItem.selectedTab = element.selectedTab;
                    }
                    if (index === 0 || index === 2) {
                        // only position 0 and position 2 has the collapse
                        basicItem.isCollapsed = element.isCollapsed ? element.isCollapsed : '2';
                    }
                    this.configForPageComponent.push(basicItem);
                } else {
                    // this part is only for safety
                    this.configForPageComponent = [
                        { componentType: ContactComponentCategory.ContactRelationships, data: this.contactRelationship, position: 1, selectedTab: 0, isCollapsed: '0', showAs: RelationshipTreeShowAs.ShortName },
                        { componentType: ContactComponentCategory.ContactNote, data: this.currentContact.notes, position: 2 },
                        { componentType: ContactComponentCategory.ContactActivity, data: this.contactActivity, position: 3, selectedTab: 0, isCollapsed: '0' },
                        { componentType: ContactBasicInformationCategory.Address, data: this.contactAddress, position: 4 }
                    ];
                }
            });
        } else {
            this.configForPageComponent = [
                { componentType: ContactComponentCategory.ContactRelationships, data: this.contactRelationship, position: 1, selectedTab: 0, isCollapsed: '0', showAs: RelationshipTreeShowAs.ShortName },
                { componentType: ContactComponentCategory.ContactNote, data: this.currentContact.notes, position: 2 },
                { componentType: ContactComponentCategory.ContactActivity, data: this.contactActivity, position: 3, selectedTab: 0, isCollapsed: '0' },
                { componentType: ContactBasicInformationCategory.Address, data: this.contactAddress, position: 4 }
            ];
        }

        if (this.configForPageComponent[0].isCollapsed === '1') {
            this.isPosition1Collapse = true;
        }
        if (this.configForPageComponent[2].isCollapsed === '1') {
            this.isPosition3Collapse = true;
        }
    }

    // when change component, need to change the data for related position
    private _changeComponent(res): void {
        this.configForPageComponent.forEach(item => {
            if (item.componentType === res.payload.origin && item.position === res.payload.originPosition) {
                item.componentType = res.payload.target;
                this.dataForPageComponent.forEach(element => {
                    if (element.componentType === res.payload.target) {
                        item.data = element.data;
                        item.selectedTab = 0;
                    }
                });
            }
        });
        if (res.payload.originPosition === 1) {
            this.isPosition1Collapse = false;
        }
        if (res.payload.originPosition === 3) {
            this.isPosition3Collapse = false;
        }
        this._changeDetectorRef.detectChanges();
    }

    // change the layout when change component
    private _changeLayout(res): void {
        if (res.type === ContactComponentActionTypes.COLLAPSE_TILE) {
            if (res.payload.originPosition === 1) {
                this.isPosition1Collapse = true;
                this.configForPageComponent[0].isCollapsed = '1';
            }
            if (res.payload.originPosition === 3) {
                this.isPosition3Collapse = true;
                this.configForPageComponent[2].isCollapsed = '1';
            }
        } else {
            if (res.payload.originPosition === 1) {
                this.isPosition1Collapse = false;
                this.configForPageComponent[0].isCollapsed = '0';
            }
            if (res.payload.originPosition === 3) {
                this.isPosition3Collapse = false;
                this.configForPageComponent[2].isCollapsed = '0';
            }
        }
    }

    // set the selectedIndex when change tab
    private _changeTab(res): void {
        this.configForPageComponent.forEach(item => {
            if (item.componentType === res.payload.origin && item.position === res.payload.originPosition) {
                // just need to change the selected tab, cannot change others
                item.selectedTab = res.payload.seletedTab;
            }
        });
    }

    private _getContactDetailPageData(): void {
        this.isDataPrepare = false;
        this._contactService.getContactDetail(this.currentContact.id).pipe(take(1)).subscribe(responses => {
            // 1. because when edit the contact in sidesheet, we need to get the contact info of current detail page,not the sidesheed entity
            // the action payload's contact is the sidesheet contact
            // so, we need to add the if to set the current contact value
            this.currentContact = Contact.parse(responses, true);
            this._initContactInformation();
            this._initEveryTile();
            this.isDataPrepare = true;
            this._changeDetectorRef.detectChanges();
        });
    }

    // get contact profile information
    private _getContactProfileInfo(): void {
        // first, need to get the information
        this.basicInfo = this._contactDetailService.getContactBasicInformation(this.currentContact, this.templateSettings);
        this.contactInfo = this._contactDetailService.getContactConnectDetail(this.currentContact);
        this.currentEmploymentInfo = this._contactDetailService.getContactEmploymentDetail(this.currentContact).currentEmploymentInfo;
        this.formerEmploymentInfo = this._contactDetailService.getContactEmploymentDetail(this.currentContact).formerEmploymentInfo;
        this.employmentInfo = this._contactDetailService.getContactEmploymentDetail(this.currentContact).employmentInfo;
        this.contactAddress = this._contactDetailService.getContactAddress(this.currentContact);
        this.internet = this._contactDetailService.getContactSocialMedia(this.currentContact);
        this.otherInfo = this._contactDetailService.getContactOtherInformation(this.currentContact, this.templateSettings);

        this.contactInformation = [
            { subject: ContactInformationItemSubject.ContactSynch, value: this.currentContact },
            { subject: ContactInformationItemSubject.BasicInformation, value: this.basicInfo },
            { subject: ContactInformationItemSubject.ContactInformation, value: this.contactInfo },
            { subject: ContactInformationItemSubject.CurrentEmployment, value: this.currentEmploymentInfo },
            { subject: ContactInformationItemSubject.FormerEmployment, value: this.formerEmploymentInfo },
            { subject: ContactInformationItemSubject.Address, value: this.contactAddress },
            { subject: ContactInformationItemSubject.Internet, value: this.internet },
            { subject: ContactInformationItemSubject.Other, value: this.otherInfo },
            {
                subject: ContactInformationItemSubject.Note, value: [
                    {
                        title: ContactInformationItemSubject.Note,
                        value: [{
                            clickable: false,
                            value: this.currentContact.notes,
                        }]
                    }]
            },
        ];
        this.contactInformation.forEach(element => {
            if (element.subject === ContactBasicInformationCategory.Note) {
                if (element.value[0].value[0].value) {
                    this.isContactProfileHasData = true;
                }
            } else if (element.value instanceof Array && element.value.length !== 0) {
                this.isContactProfileHasData = true;
            }
        });
        if (!this.isContactProfileHasData) {
            this.contactInformation = [];
        }
    }

    // get relationships for relationship part
    private _getRelationshipsTileData(): void {
        this.contactRelationship = [];
        // prepare the data for relationship part - All
        this.contactRelationship = RelationshipTreeService.parseToTreeViewModel(this.currentContact);
    }

    // a common function to get the time for later or before days
    private _getDateAfterDays(dayCount): number {
        const currentDay = new Date();
        currentDay.setDate(currentDay.getDate() + dayCount);
        const time = currentDay.getTime();
        return time;
    }

    // to refresh the relationship tile in contact detail page
    private _refreshRelationshipTile(): void {
        // this part is for relationship
        this._contactService.getContactDetail(this.currentContact.id).pipe(take(1)).subscribe((response) => {
            this.currentContact = Contact.parse(response);
            this._store.dispatch({
                type: GET_CONTACT_SUCCESS,
                payload: this.currentContact
            });
            this._getRelationshipsTileData();
            this.dataForPageComponent.forEach(element => {
                if (element.componentType === ContactComponentCategory.ContactRelationships) {
                    element.data = this.contactRelationship;
                }
            });
            this._contactDetailService.action$.next({
                type: ContactComponentActionTypes.RELOAD_RELATIONSHIP,
                payload: this.contactRelationship
            });
            this._changeDetectorRef.detectChanges();
        });
    }
}
